// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionRunSummaryDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionRunStatus } from "./chat-regression-run-status.enum.gen";
import { ChatRegressionRunScope } from "./chat-regression-run-scope.enum.gen";
import { ChatRegressionSummaryGenShape } from "./chat-regression-summary.gen";

export const ChatRegressionRunSummaryDtoGenShape = z.strictObject({
  id: z.string(),
  workflowId: z.string(),
  workflowDocumentId: z.string(),
  libraryId: z.string(),
  status: z.enum(ChatRegressionRunStatus),
  isPartial: z.boolean(),
  scope: z.enum(ChatRegressionRunScope),
  caseCount: z.number(),
  summary: ChatRegressionSummaryGenShape,
  passed: z.boolean(),
  ranAt: z.string(),
  ranBy: z.string().optional(),
});
